$(document).ready(function(){
    // Drawer
    $("a.drawer-open").on('click', function(){
        $("section.map").addClass('drawer-opened');
    });
    $("#drawer a.close-it").on('click', function(){
        $("section.map").removeClass('drawer-opened');
    });

    $(document).click(function(event) {
        if( $(event.target).hasClass('drawer-opened') ){
            $("section.map").removeClass('drawer-opened');
        }
        // if( !$(event.target).hasClass('map-infobar__spot') ){
        //     $(".map-infobar__spot").hide();
        // }
    });

    $("a.fpo-spot-available").on('click', function(){
        $(".spot__available").toggle();
    });
    $("a.fpo-spot-filtered").on('click', function(){
        $(".spot__filtered").toggle();
    });
    $("a.fpo-spot-mine").on('click', function(){
        $(".spot__mine").toggle();
    });
    $("a.fpo-spot-unavailable").on('click', function(){
        $(".spot__unavailable").toggle();
    });

    // Map page from icons show/hide
    $("a[class*='show-page']").on('click', function(){
        $(".map-page__default#page-icons").show();
        $(".map-page__default#page-icons div[id^='page-']").hide();
        $('body').addClass('show-page');
        if( $(this).hasClass('show-page-search') ){
            $(".map-page__default#page-icons #page-search").show();
        } else if( $(this).hasClass('show-page-people') ){
            $(".map-page__default#page-icons #page-people").show();
        } else if( $(this).hasClass('show-page-help') ){
            $(".map-page__default#page-icons #page-help").show();
        }

        $(".map-page__default#page-icons .map-page-body input[type='text']").focus();
    });
    $(".map-page__default#page-icons a.hide-map-page").on('click', function(){
        $(this).closest(".map-page__default").hide();
        $('body').removeClass('show-page');
        $(this).closest(".map-page__default").find(".map-page-body input[type='text']").blur();
    });

    $("a.show-checkout-page").on('click', function(){
        $(".map-page__default#page-checkout").show();
        $('body').addClass('show-page');
    });
    $(".map-page__default#page-checkout a.hide-checkout-page").on('click', function(){
        $('body').removeClass('show-page');
        $(this).closest(".map-page__default").hide();
    });

    $("a.show-areyousure-page").on('click', function(){
        $(".map-page__default#page-areyousure").show();
        $('body').addClass('show-page');
    });
    $(".map-page__default#page-checkout a.hide-areyousure-page").on('click', function(){
        $('body').removeClass('show-page');
        $(this).closest(".map-page__default").hide();
    });

    // Map page show/hide
    $("a.show-map-page-message").on('click', function(){
        $(".map-page__message").show();
        $(".map-page__message div[id^='message-']").hide();
        if( $(this).hasClass("message-confirmed") ){
            $(".map-page__message #message-confirmed").show();
        } else if( $(this).hasClass("message-intro") ){
            $(".map-page__message #message-intro").show();
        } else if( $(this).hasClass("message-loading") ){
            $(".map-page__message #message-loading").show();
        }
    });
    $(".map-page__message a.hide-map-page-message").on('click', function(){
        $(".map-page__message").hide();
    });

    // Radio buttons
    $('.radio input[type=radio]').on('change', function () {
        $('.radio label span').empty();
        $('.radio').removeClass('radio-checked');
        $(this).closest('.radio').find('label span').html('Will be removed');
        $(this).closest('.radio').addClass('radio-checked');
    });

    // Show details of spot
    $.fn.toggleText = function(t1, t2){
      if (this.text() == t1) this.text(t2);
      else                   this.text(t1);
      return this;
    };


    //checkboxes
    // $('.checkbox-tag__individual input[type="checkbox"]').prop('checked', false);
    // $('.checkbox-tag__all input[type="checkbox"]').prop('checked', true);
    // $('.checkbox-tag__all').on('click', function(){
    //     // Don't allow uncheck of 'All' when it's checked
    //     if( $(this).find('input[type="checkbox"]').is(':checked') ){
    //         return false;
    //     } else{
    //         $(this).find('input[type="checkbox"]').prop('checked', true);
    //         $(this).closest('.form-group').find('.checkbox-tag__individual input[type="checkbox"]').prop('checked', false);
    //     }
    // });
    // $('.checkbox-tag__individual input[type=checkbox]').on('change', function () {
    //     // See is any are checked, if not 'Check All'
    //     var len = $(this).closest('.form-group').find('label.checkbox-tag__individual input[type=checkbox]:checked').length;
    //     if (len > 0) {
    //         // Some are checked
    //         $(this).closest('.form-group').find('.checkbox-tag__all input[type="checkbox"]').prop('checked', false);
    //     }else if (len === 0){
    //         // None checked, so go back to check all
    //         $(this).closest('.form-group').find('.checkbox-tag__all input[type="checkbox"]').prop('checked', true);
    //     }
    // });

// Show details of spot
// $.fn.toggleText = function(t1, t2){
//   if (this.text() == t1) this.text(t2);
//   else                   this.text(t1);
//   return this;
// };
// $("body").on('click', 'a.btn-details', function(e){
//   e.preventDefault();
//   $(this).focusout().blur();
//   // $(this).closest('.map-infobar__spot').toggleClass('opened');
//   // $('section.map').toggleClass('backdrop');
//   // $(this).toggleText('Close', 'Details');
// });

//checkboxes
// $('.checkbox-tag__individual input[type="checkbox"]').prop('checked', false);
// $('.checkbox-tag__all input[type="checkbox"]').prop('checked', true);
// $('.checkbox-tag__all').on('click', function(){
//   // Don't allow uncheck of 'All' when it's checked
//   if( $(this).find('input[type="checkbox"]').is(':checked') ){
//     return false;
//   } else{
//     $(this).find('input[type="checkbox"]').prop('checked', true);
//     $(this).closest('.form-group').find('.checkbox-tag__individual input[type="checkbox"]').prop('checked', false);
//   }
// });
// $('.checkbox-tag__individual input[type=checkbox]').on('change', function () {
//   // See is any are checked, if not 'Check All'
//   var len = $(this).closest('.form-group').find('label.checkbox-tag__individual input[type=checkbox]:checked').length;
//   if (len > 0) {
//     // Some are checked
//     $(this).closest('.form-group').find('.checkbox-tag__all input[type="checkbox"]').prop('checked', false);
//   }else if (len === 0){
//     // None checked, so go back to check all
//     $(this).closest('.form-group').find('.checkbox-tag__all input[type="checkbox"]').prop('checked', true);
//   }
// });

// var timer = 0;
// var elems = $($("#toaster-messages div[class^='toaster']").get().reverse());

// if (elems.length){
//     var elemsCount = elems.length;
//     $(elems).each( function(k, v) {
//         var el = this;
//         var speed = 300;
//         setTimeout(function () {
//             $(el).addClass('animated bounceInUp');
//         }, k*speed);
//         timer = k*speed;
//     });
//     // Now we remove the 'success' automatically
//     setTimeout(function () {
//         $("#toaster-messages div[class^='toaster-success']").fadeOut('fast', function(){
//             $(this).remove();
//         });
//     }, timer+4000);
//     // Remove each message on click
//     elems.find('a.close-it').on('click', function(){
//         $(this).closest("div[class^='toaster-']").fadeOut('fast', function(){
//             $(this).remove();
//             // recalculate and remove parent div if there are no messages left
//             var elemsLeft = $("#toaster-messages div[class^='toaster']");
//             if(elemsLeft.length == 0){
//                 $('#toaster-messages').remove();
//             }
//         });
//     });
// } // @END: if elems.length
// $(function () {
    //   $('.affixit').affix();
// });


});

if (document.all) {
    $('body').prepend('<div class="ie-upgrade">You are using an unsupported browser. To access all the functionality, we recommend using Chrome, IE11+, IE Edge, Firefox or Safari.</div>');
}

// $('body').on('click', 'a.close-it', function(e){
//     e.preventDefault();
//     $(this).closest("div[class^='toaster-']").fadeOut('fast', function(){
//         $(this).remove();
//     });
// });


// Popovers
// $(function () {
// $('[data-toggle="tooltip"]').tooltip({
//   container: 'body'
// })
// });


// var svg = document.querySelector("svg");
// var paths = document.querySelectorAll("g.path");
// var i = paths.length;
// while(i--) {
//   paths[i].addEventListener("mouseenter", function(e) {
//       this.closest('g.group').appendChild(e.target);
//     // svg.appendChild(e.target);
//   });
// }

// setTimeout(function(){
//   $("svg.leaflet-zoom-animated g path").on("mouseenter", function(e) {
//       this.closest('g').appendChild(e.target);
//   });
// },3000);
